import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Table } from 'react-bootstrap';
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { purgeJobs } from '../../apis/jobApi';

export const PurgeJobs = () => {
    const [jobIds, setJobIds] = useState('');
    const [alert, setAlert] = useState(null);
    const purgeMutaiton = useMutation({
        mutationFn: async (jobIds) => {
            return purgeJobs(jobIds);
        },
        onSuccess: (data) => {
            const succeeded = data.filter(result => result.success).map(result => result.id);
            const failed = data.filter(result => !result.success);
            let failedExists = false;
            
            if (failed.length > 0) {
                
                failedExists = true;
                const variant = 'warning';
                const message = (
                    <>
                    <div>Some jobs failed to purge: </div>
                    <Table bordered size="sm" className='error-table table-warning' style={{ tableLayout: 'fixed', width: '100%' }}>
                        <thead>
                            <tr>
                                <th style={{ width: '30%' }}>Job Id </th>
                                <th style={{ width: '70%' }}>Error Message</th>
                            </tr>
                        </thead>
                        <tbody>
                        {failed.map((fail, index) => 
                        {
                         return <tr key={index}>
                            <td className='error-cell'>{fail.id}</td>
                            <td className='error-cell'>{fail.error}</td>
                            </tr>
                            })}
                        </tbody>
                    </Table>
                    <div>Please ensure the ids submitted exist and/or are correctly formatted.</div>
                    </>
                );
                setAlert({ message: message, variant:variant });
            }
            if(succeeded.length > 0) {
                const successMessage = `Successfully purged jobs: ${succeeded.join(', ')}`;
                if(failedExists) {
                    setAlert(prevAlert => ({
                        message: (
                            <>{prevAlert.message}
                            <div>
                                {successMessage}
                            </div></>),
                        variant: prevAlert.variant
                    }));
                }
                else
                {
                    const variant = 'success';
                    setAlert({ message:successMessage, variant:variant });
                }
            }
        },
        onError: (error) => {
            console.error("Error purging jobs: ", error);
        }

    });

    const handleSubmit = (e) => {
        e.preventDefault();
        if(jobIds.length === 0)
        {
            setAlert({ message: "Please enter at least one Job Id to purge.", variant: "warning" });
        }

        const jobs = jobIds.split(',').map(id => id.trim()).filter(id => id).flatMap(id => 
        {
            if (id.includes("-")) { 
                var rangeSplit = id.split("-"); 
                const firstIdValueMatch = rangeSplit[0].match(/^([^0-9]+)(\d+)/)
                
                var prefix = '';
                
                if(firstIdValueMatch)
                {
                    prefix = firstIdValueMatch[1];
                    rangeSplit[0] = firstIdValueMatch[2];
                }
                else
                {
                    const firstNumberMatch = rangeSplit[0].match(/\d+$/)[0]
                    if (firstNumberMatch)
                    {
                        rangeSplit[0] = firstNumberMatch;
                    }
                }
                const secondIdValueMatch = rangeSplit[1].match(/^([^0-9]+)(\d+)/)
                
                if (secondIdValueMatch)
                {
                    rangeSplit[1] = secondIdValueMatch[2];
                }
                else
                {
                    const secondNumberMatch = rangeSplit[1].match(/\d+$/)[0]
                    if (secondNumberMatch)
                    {
                        rangeSplit[1] = secondNumberMatch;
                    }
                }
                var start = parseInt(rangeSplit[0]);
                var end = parseInt(rangeSplit[1]);
                if(start > end)
                {
                    [start, end] = [end, start];
                }
                return Array.from({length: (end -start + 1)}, (value, index) =>  prefix + (start + index));;

            } 
            else 
            { 
                return id; 
            }
        });
        
        purgeMutaiton.mutate(jobs);
    }

    return<> 
    {
        alert && <Alert variant={alert.variant} dismissible onClose={() => setAlert(null)}>
            {alert.message}
        </Alert>
    }
    
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3" controlId="formPurgeIds">
        <Form.Label><h4>Enter Jobs Ids To Purge</h4></Form.Label>
        {
            purgeMutaiton.isPending ? (
                 <Container fluid className="pending-container">
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status" style={{width: '3rem', height: '3rem'}}>
                            <span className="visually-hidden">Loading job details...</span>
                        </div>
                        <div className="mt-3">
                            <h5>Purging Jobs</h5>
                            <p className="text-muted">Please wait while the requested jobs are purged...</p>
                        </div>
                    </div>
                </Container>
            ):(
        
        <Form.Control 
            as="textarea" 
            placeholder="Separate multiple Job Ids with commas" 
            rows={5}
            value={jobIds}
            onChange={(e) => setJobIds(e.target.value)}/>
            )}
        </Form.Group>
        <Row>
            <Col className="d-flex justify-content-end">
                <Button className='jobAction button-table' type="submit">
                    Purge
                </Button>
            </Col>
        </Row>
    </Form>
    </>

}
